import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, CircularProgress } from '@mui/material';
export const ButtonWithProgress = props => {
    return (_jsxs(Box, { component: 'div', sx: [{ position: 'relative' }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])], children: [_jsx(Button, { variant: 'contained', color: props.color || 'secondary', disabled: props.working || props.error, autoFocus: props.autoFocus, onClick: props.onClick, title: props.title, startIcon: props.startIcon, disableTouchRipple: true, children: props.children }), props.working ? (_jsx(CircularProgress, { size: 24, sx: {
                    color: 'secondary.main',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    mt: '-12px',
                    ml: '-12px'
                } })) : null] }));
};
//# sourceMappingURL=button-with-progress.js.map